import React from 'react'
import Door1 from '../img/Door Window/Door Window 1.jpg'
import Door2 from '../img/Door Window/Door Window 2.jpg'
import Door3 from '../img/Door Window/Door Window 3.jpg'
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { AnimationOnScroll } from 'react-animation-on-scroll'

function Door() {
  const location = useLocation();
  const componentRef = useRef(null);

  useEffect(() => {
    if (componentRef.current) {
      setTimeout(() => {

        componentRef.current.scrollIntoView({ behavior: "smooth" });
      }, 3000);
    }
  }, [location])
  return (
    <section ref={componentRef}>
      <div className="about">
        <h2 id="Content">Door Window Design</h2>
      </div>
      <div className="DispalyingImage">
        <AnimationOnScroll animateIn='slipeLeft'>
          <img src={Door1} alt="" className="DisImg" />
        </AnimationOnScroll>
        <AnimationOnScroll animateIn='slipeLeft'>
          <img src={Door2} alt="" className="DisImg" />
        </AnimationOnScroll>
        <AnimationOnScroll animateIn='slipeLeft'>
          <img src={Door3} alt="" className="DisImg" />
        </AnimationOnScroll>
      </div>
    </section>
  )
}

export default Door
